import { inject, PLATFORM_ID, signal } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { StorageService } from '../services/storage.service';
import { isPlatformBrowser } from '@angular/common';

export const loginGuard: CanActivateFn = (route, state) => {
  let _router =inject(Router);
  let platformId = inject(PLATFORM_ID);
  if (isPlatformBrowser(platformId)){
    let token =  sessionStorage.getItem("token");
    // console.log('token',token);
  
    if(token){  
      return true;
    }else{
    _router.navigate(['/student/login'])
    return false;
   }
  }else{
    return true;
  }
  
 
};
